/**
 * Helper functions for checking payment access
 */

/**
 * Check if user has paid for listing access
 * @param {Object} currentUser - The current user object
 * @returns {boolean} - True if user has listing access
 */
export const hasListingAccess = (currentUser) => {
  if (!currentUser) return false;
  
  // Check if listing creation is free from environment variable
  const isListingFree = process.env.REACT_APP_CREATE_LISTING_FREE === 'true';
  if (isListingFree) return true;
  
  const privateData = currentUser?.attributes?.profile?.privateData || {};
  return Boolean(privateData.hasListingAccess);
};

/**
 * Check if user has paid for search access
 * @param {Object} currentUser - The current user object
 * @returns {boolean} - True if user has search access
 */
export const hasSearchAccess = (currentUser) => {
  if (!currentUser) return false;
  
  // Check if search is free from environment variable
  const isSearchFree = process.env.REACT_APP_SEARCH_FREE === 'true';
  if (isSearchFree) return true;
  
  const privateData = currentUser?.attributes?.profile?.privateData || {};
  return Boolean(privateData.hasSearchAccess);
};

/**
 * Get payment redirect URL
 * @param {string} type - Payment type ('listing' or 'search')
 * @returns {string} - Redirect URL for payment
 */
export const getPaymentURL = (type) => {
  return `/payment?type=${type}`;
};

